<ng-template
  #authRequestModal
  let-modal
  >
  <div
    class="modal-body"
    i18n="@@grantRecordingPermission"
    >
    Aufnahme erlauben?
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-secondary"
      (click)="submitModal(false)"
      i18n="@@globalNo"
    >Nein</div>
    <div
      class="btn btn-primary"
      (click)="submitModal(true)"
      i18n="@@globalYes"
    >Ja</div>
  </div>
</ng-template>

<ng-template
  #addCommentModal
  let-modal
  >

  <div
    class="modal-body"
    i18n="@@addCommentToFeedbackInvitation"
    >
    Fügen Sie Ihrer Feedbackeinladung einen Kommentar hinzu.
    <textarea
      #comment
      class="form-control"
    ></textarea>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-secondary"
      (click)="closeCommentModal()"
      i18n="@@globalNo"
    >Nein</div>
    <div
      class="btn btn-primary"
      (click)="collectComment(comment.value)"
      i18n="@@globalYes"
    >Ja</div>
  </div>
</ng-template>

<ng-template #recordWith2ndDevice>
  <div
    class="alert alert-notice-header"
    [style.backgroundColor]="layoutService.gray50.backgroundColor"
    i18n="@@recordExerciseWithPhone"
  >Übung mit einem Smartphone aufzeichnen</div>
  <div
    class="text-center m-auto"
    style="width: 256px"
    >
    <a
      [href]="getQrCodeUrl()"
      target="_blank"
      >
      <qrcode
        [qrdata]="getQrCodeUrl()"
        [width]="256"
        [margin]="0"
      ></qrcode>
    </a>
  </div>
  <div class="alert alert-danger mt-3"><i class="ri-alarm-warning-fill"></i>
  <span i18n="@@recordScreenLockWarning">Bitte
      schalten Sie Ihre automatische Bildschirmsperre aus, um eine reibungslose
      Aufnahme sicherzustellen.</span>
</div>
</ng-template>
<ng-template #recordAVideo>
  <div
    class="alert alert-notice-header"
    [style.backgroundColor]="layoutService.gray50.backgroundColor"
    i18n="@@recordExercise"
    >Übung aufzeichnen
  </div>


  @if (this.conversionStatus=='idle' && !isRecorded && !pack.secondDevice) {
    <app-video-recording
      [is2ndDevice]="false"
    ></app-video-recording>
  }
  @if (this.conversionStatus!='idle') {
    @if (this.conversionProgress> 0) {
      <h3
        i18n="@@videoRecordConversion"
      >Video wird verarbeitet: {{this.conversionProgress | percent}}</h3>
    }
    @if (this.conversionProgress == 0) {
      <h3
        i18n="@@videoRecordWaiting"
      >Video in Warteschlange</h3>
    }
  }
</ng-template>
<ng-template #showRecordedVideo>
  <div
    class="
    alert
    alert-notice-header"
    [style.backgroundColor]="layoutService.gray50.backgroundColor"
    i18n="@@recordedExercise"
    >Aufzeichnung der Übung
  </div>
  <div
    class="recordedvideo"
    style="display: none"
    [ngClass]="{'d-block': isRecorded, 'd-none': !isRecorded}"
    style="background: #000000"
    >
    <video
      #recording
      controls
      width="100%"
      controlsList="nodownload"
      disablePictureInPicture
      [src]="this.recordingSrc"
    ></video>
  </div>
  <hr>
    <button
      #deleteBtn
      class="btn btn-sm btn-sm btn-danger mb-2"
      (click)="openConfirmDeleteRecord()"
      [ngClass]="{'disabled': !participantVideo}"
      i18n="@@globalDelete"
      >Löschen
  </button>
  </ng-template>

  <div class="row text-left mx-0">
    <div class="col-12 ">
      <app-document-tab-buttons
        [allparticipants]="allparticipants"
        [aRoute]="aRoute"
        [selectedEvent]="selectedeventobject"
      ></app-document-tab-buttons>
      <div class="row px-4 pt-0">
        <div class="col-12 col-lg-6">
          @if (pack.secondDevice && !isRecorded) {
            <div>
              <ng-container *ngTemplateOutlet="recordWith2ndDevice"></ng-container>
            </div>
          }

          @if (!pack.secondDevice && !isRecorded) {
            <div>
              <ng-container *ngTemplateOutlet="recordAVideo"></ng-container>
            </div>
          }

          @if ((recorderState === 'inactive' || 'stopped') && isRecorded) {
            <div>
              <ng-container *ngTemplateOutlet="showRecordedVideo"></ng-container>
            </div>
          }
        </div>
        @if (pack && pack.disableVideofeedback === 'normal') {
          <div
            class="col-12 col-lg-6"
            >
            <div
              class="alert alert-notice-header"
              [style.backgroundColor]="layoutService.gray50.backgroundColor"
              i18n="@@inviteParticipantsForFeedback"
              >
          Teilnehmer zum Feedback einladen
        </div>
            <ul
              style="width:100%"
              role="menu"
              >
              @for (participant of allparticipants; track participant) {
                <li
                  role="menuitem"
                  style="list-style-type: none"
                  >
                  @if (participantVideo) {
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [id]="'participantcheckbox_'+participant.id"
                      [checked]="participantVideo.metadata.feedbackpeers.includes(participant.id)"
                      (change)="changeInvitationStatusForParticipant($event, participant.id)"
                      >
                    <label
                      class="form-check-label"
                      [for]="'participantcheckbox_'+participant.id"
                    >{{participant.fullNameWithIndex}}</label>
                  } @else {
                    <input
                      type="checkbox"
                      disabled
                      class="mr-2"
                      >
                    <label
                      class="form-check-label"
                      [appLayout]="layoutService.textColor50"
                      [for]="'participantcheckbox_'+participant.id"
                    >{{participant.fullNameWithIndex}}</label>
                  }
                  <table>
                    <tr>
                      <td valign="top"><i
                        class="ri-message-2-fill mr-2"
                        [appLayout]="layoutService.activeColor"
                        style="transform: scaleX(-1)"
                        [appLayoutColorFlip]="true"
                      ></i></td>
                      <td valign="top">
                        @if (ratingComment[participant.id]) {
                          {{ratingComment[participant.id]}}
                        } @else {
                          <span
                            i18n="@@noFeedback"
                            [appLayout]="layoutService.textColor50"
                          >Kein Feedback</span>
                        }
                      </td>
                    </tr>
                  </table>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>